import { getOnboardingSports } from './sports';

// Onboarding flow configuration
export const ONBOARDING_ROUTES = [
  '/onboarding/sports',
  '/onboarding/markets',
  '/onboarding/bet-type',
  '/onboarding/bet-timing',
  '/onboarding/odds',
];

// Get current step number from route path
export const getCurrentStep = (routePath) => {
  const index = ONBOARDING_ROUTES.indexOf(routePath);
  return index !== -1 ? index + 1 : 1;
};

// Get total number of onboarding steps
export const getTotalSteps = () => ONBOARDING_ROUTES.length;

// Sports from unified config
export const SPORTS = getOnboardingSports();

// Markets data - name matches backend API keys exactly
// label values are i18n translation keys
export const MARKETS = [
  { id: 1, name: 'to_win', label: 'onboardingOptions.markets.toWin', enabled: false },
  { id: 2, name: 'total_goals', label: 'onboardingOptions.markets.totalGoals', enabled: false },
  { id: 3, name: 'btts', label: 'onboardingOptions.markets.btts', enabled: false },
  { id: 4, name: 'handicaps', label: 'onboardingOptions.markets.handicaps', enabled: false },
  { id: 5, name: 'correct_score', label: 'onboardingOptions.markets.correctScore', enabled: false },
  { id: 6, name: 'corners_cards', label: 'onboardingOptions.markets.cornersCards', enabled: false },
  { id: 7, name: 'player_markets', label: 'onboardingOptions.markets.playerMarkets', enabled: false },
  { id: 8, name: 'period_markets', label: 'onboardingOptions.markets.periodMarkets', enabled: false },
];

// Bet types data - name matches backend API keys exactly
// label values are i18n translation keys
export const BET_TYPES = [
  { id: 1, name: 'singles', label: 'onboardingOptions.betTypes.singles', enabled: false },
  { id: 2, name: 'acca_doubles', label: 'onboardingOptions.betTypes.accaDoubles', enabled: false },
  { id: 3, name: 'acca_trebles', label: 'onboardingOptions.betTypes.accaTrebles', enabled: false },
  { id: 4, name: 'acca_4plus', label: 'onboardingOptions.betTypes.acca4plus', enabled: false }
];

// Bet timing data - name matches backend API keys exactly
// label values are i18n translation keys
export const BET_TIMING = [
  { id: 1, name: 'live', label: 'onboardingOptions.betTiming.live', enabled: false },
  { id: 2, name: 'pre_game', label: 'onboardingOptions.betTiming.preGame', enabled: false }
];

// Risk/Odds appetite data - name matches backend API keys exactly
// label values are i18n translation keys
export const RISK = [
  { id: 1, name: 'low', label: 'onboardingOptions.risk.low', enabled: false },
  { id: 2, name: 'medium', label: 'onboardingOptions.risk.medium', enabled: false },
  { id: 3, name: 'high', label: 'onboardingOptions.risk.high', enabled: false },
  { id: 4, name: 'very_high', label: 'onboardingOptions.risk.veryHigh', enabled: false }
];

// Content preferences - name matches backend API keys exactly
// label values are i18n translation keys
export const CONTENT = [
  { id: 1, name: 'detailed_previews', label: 'onboardingOptions.content.detailedPreviews', enabled: false },
  { id: 2, name: 'visual_stats', label: 'onboardingOptions.content.visualStats', enabled: false },
  { id: 3, name: 'trends', label: 'onboardingOptions.content.trends', enabled: false },
  { id: 4, name: 'accumulators', label: 'onboardingOptions.content.accumulators', enabled: false },
  { id: 5, name: 'quick_tips', label: 'onboardingOptions.content.quickTips', enabled: false },
  { id: 6, name: 'betbuilder', label: 'onboardingOptions.content.betbuilder', enabled: false }
];
